import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button.tsx'
import { Card, CardContent } from '@/components/ui/card'
import { BACKEND_BASE_URL } from '@/config.ts'
import { useUserContext } from '@/contexts/UserContext.tsx'

export const LoginPage = () => {
  const { user } = useUserContext()
  const navigate = useNavigate()

  const location = useLocation()
  const { source, invitationCode } = location.state || {}

  useEffect(() => {
    if (user) {
      if (source === 'invites' && invitationCode) {
        navigate(`/invites/${invitationCode}`)
      } else {
        navigate('/welcome')
      }
    }
  }, [navigate, user, source, invitationCode])

  const loginLink =
    source === 'invites' && invitationCode
      ? `${BACKEND_BASE_URL}/oauth2/authorization/google?source=${source}&invitation_code=${invitationCode}`
      : `${BACKEND_BASE_URL}/oauth2/authorization/google`

  return (
    <main className="flex h-dvh items-center justify-center bg-surface-primary p-4">
      <Card className="w-[512px] border-border-default-neutral bg-surface-backgroundElevated py-12">
        <CardContent className="p-0 flex flex-col items-center space-y-8">
          <div className="flex items-center gap-2">
            <img src="/images/tb-logo.svg" alt="Tracker Boot logo" className="h-6 w-[26px] object-contain" />
            <img
              src="/images/tb-logo-text.svg"
              alt="Tracker Boot logo text"
              className="h-[18px] w-[142px] object-contain"
            />
          </div>

          <div className="flex w-full flex-col items-center space-y-5">
            <p className="flex flex-col items-center h-12">
              <span className="font-EN-KR-sub-heading-bold text-contents-primary">Welcome to Tracker Boot!</span>
              <span className="font-EN-KR-sub-heading-regular text-contents-secondary text-center">
                Now Live: Simple, powerful, made for agile product teams.
              </span>
            </p>

            <Button
              variant="outline"
              className="flex w-[283px] h-12 items-center justify-center gap-2 bg-surface-backgroundElevated border-border-default-neutral py-3 font-EN-KR-body1-regular text-contents-primary rounded-xs"
              onClick={() => {
                window.location.replace(loginLink)
              }}
            >
              <img src="/images/google-logo.svg" alt="Google logo" className="h-6 w-6 object-cover" />
              Continue with Google
            </Button>
          </div>
        </CardContent>
      </Card>
    </main>
  )
}
